<div>
  @if (loading) {
    <p-skeleton width="100%" height="175px" borderRadius="12px" class="mb-20" />
  } @else if (data) {
    <div class="bordered-section mb-16">
      <div class="mb-20" style="display: flex; gap: 12px;">
        <div>
          <p-avatar
            [image]="data.agentAvatar"
            [label]="data.agentAvatar ? undefined : data.agentInitials"
            class="agent-avatar"
            size="large"
            shape="circle"
          />
        </div>

        <div>
          <div class="mb-4" style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap">
            <div class="black-font fs-18 fw-600" style="margin-right: 8px;">{{data.agentName}}</div>
            @if (data.risk === RiskEnum.Low) {
              <p-tag severity="success" value="Low Risk" />
            } @else if (data.risk === RiskEnum.Medium) {
              <p-tag severity="warn" value="Med Risk" />
            } @else {
              <p-tag severity="danger" value="High Risk" />
            }
          </div>
          <div class="fw-500 mb-4">{{data.teamName}}</div>
          <div class="blue-font fs-14">Added to Loop: {{data.dateAddedToLoop | dateTime:'DD/MM/YYYY'}}</div>
        </div>
      </div>

      <div style="display: flex; gap: 8px; flex-wrap: wrap;">
        <div style="display: flex; gap: 12px; flex: 1 1 auto;">
          <div class="icon-box">
            <i class="pi pi-exclamation-triangle" style="font-size: 1.5rem"></i>
          </div>

          <div style="display: flex; flex-direction: column; justify-content: space-between">
            <div class="blue-font">Withdrawn All Time</div>
            <div class="fs-24 fw-700">{{data.withdrawnAllTimeCount | number}}</div>
          </div>
        </div>

        <div style="display: flex; gap: 12px; flex: 1 1 auto;">
          <div class="icon-box">
            <i class="pi pi-shield" style="font-size: 1.5rem"></i>
          </div>

          <div style="display: flex; flex-direction: column; justify-content: space-between">
            <div class="blue-font">Withdrawal Value</div>
            <div class="fs-24 fw-700">{{data.withdrawnAllTimeValue | loopCurrency}}</div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (loading) {
    <p-skeleton width="100%" height="147px" borderRadius="12px" />
  } @else if (data) {
    <div class="bordered-section">
      <div class="fs-18 fw-500 black-font mb-16">Properties</div>

      <div class="properties-details-wrapper">
        <div>
          <div class="blue-font mb-8">Currently On Market</div>
          <div class="fw-700 fs-24">{{data.currentlyOnMarketCount | number}}</div>
        </div>

        <p-divider layout="vertical" />

        <div>
          <div class="blue-font mb-8">Currently Under Offer</div>
          <div class="fw-700 fs-24">{{data.currentlyUnderOfferCount | number}}</div>
        </div>

        <p-divider layout="vertical" />

        <div>
          <div class="blue-font mb-8">All Time Exchanged</div>
          <div class="fw-700 fs-24">{{data.allTimeExchangedCount | number}}</div>
        </div>

        <p-divider layout="vertical" />

        <div>
          <div class="blue-font mb-8">All Time Exchanged Value</div>
          <div class="fw-700 fs-24">{{data.allTimeExchangedValue | loopCurrency}}</div>
        </div>
      </div>
    </div>
  }
</div>
